<template>
  <div class="feedback-wrapper">
    <div class="feedback">
      <div :class="'feedback-icon ' + imageTitle"></div>

      <div class="feedback-title" v-html="textTitle"></div>

      <div class="feedback-message">
        {{ textDescription }}
      </div>

      <div class="feedback-info" v-if="!hideFeedbackInfo">
        Ligue para <span>3911</span> se estiver na Globo<br />
        Se estiver fora, ligue para <span>0800 728 4855</span>
      </div>

      <div class="feedback-actions" v-if="showButtons">
        <v-btn
          large
          color="primary"
          class="white--text"
          @click="$emit('click')"
        >
          {{ btnText }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    textTitle: String,
    textDescription: String,
    subText: String,
    imageTitle: String,
    btnText: {
      value: String,
      default: 'Voltar à página inicial',
    },
    showButtons: Boolean,
    hideFeedbackInfo: Boolean,
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      isLoggedIn: state => !!state.user.isLoggedIn,
    }),
  },

  methods: {
    tryAgain() {
      this.$store.dispatch('getFolders');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/fixes.scss';
@import '@/assets/scss/theme-v2.scss';

.feedback-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: $color-background;
  transition: all 0.4s ease-in-out;
  animation: fadeIn 1.6s forwards;

  // Estilo específico para o caso de erro dentro de um box
  &.inside {
    position: relative;
    top: inherit;
    left: inherit;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    margin: 16px 0 8px 0;
    background-color: transparent;

    .texture {
      display: none;
    }

    &.content-panel {
      align-content: flex-start;
      align-items: flex-start;
      padding-top: 40px;
    }
  }

  .feedback {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    max-width: 480px;
    flex-direction: column;

    @include for-size(phone-only) {
      max-width: 100%;
    }

    // Definições para o slot de icone do feedback
    .feedback-icon {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: 124px;
      flex: 1 1 auto;
      margin: 0 0 8px 0;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center center;
      will-change: background-image;
      transition: background-image 0.6s ease-in-out;
      cursor: pointer;

      @include for-size(phone-only) {
        height: 116px;
      }

      &:hover {
        will-change: background-image;
        transition: background-image 0.6s ease-in-out;
      }

      &:focus,
      &:active {
        will-change: background-image;
        transition: background-image 0.6s ease-in-out;
        animation: tada 0.8s ease-in-out;
      }

      &.bored {
        background-image: url('../../assets/images/panda-bored-01.svg');
        &:hover,
        &:focus,
        &:active {
          background-image: url('../../assets/images/panda-bored-02.svg');
        }
      }

      &.hungry {
        background-image: url('../../assets/images/panda-hungry-01.svg');
        &:hover,
        &:focus,
        &:active {
          background-image: url('../../assets/images/panda-hungry-02.svg');
        }
      }

      &.detective {
        background-image: url('../../assets/images/panda-detective-01.svg');
        &:hover,
        &:focus,
        &:active {
          background-image: url('../../assets/images/panda-detective-02.svg');
        }
      }

      &.artboard {
        background-image: url('../../assets/images/panda-artboard-01.svg');
        &:hover,
        &:focus,
        &:active {
          background-image: url('../../assets/images/panda-artboard-02.svg');
        }
      }

      // ICON
      img {
        height: 100%;
        width: auto;
      }
    }
    // -------

    // Definições para o slot de título
    .feedback-title {
      flex: 0 0 100%;
      font-size: 2em;
      font-family: 'globotipo' !important;
      font-weight: 300 !important;
      font-style: italic;
      color: $color-black-80;
      line-height: 1em;
      text-align: center;

      ::v-deep span {
        font-family: 'globotipo' !important;
        font-weight: 600 !important;
      }

      @include for-size(phone-only) {
        flex: 0 0 72%;
        font-size: 1.4em;
      }
    }
    // -------

    // Definições para o slot de mensagem
    .feedback-message {
      flex: 0 0 72%;
      margin: 16px 0 0 0;
      font-size: 0.88em;
      font-style: italic;
      color: $color-black-56;
      line-height: 1.2em;
      text-align: center;

      span {
        font-family: 'globotipo' !important;
        font-weight: 600 !important;
      }

      @include for-size(phone-only) {
        flex: 0 0 80%;
        font-size: 0.88em;
        margin: 8px 0 0 0;
      }
    }
    // -------

    // Definições para o slot de informações extras
    .feedback-info {
      flex: 0 0 88%;
      padding: 16px;
      margin: 24px 0 0 0;
      font-size: 1em;
      font-style: italic;
      line-height: 1.2em;
      text-align: center;
      color: $color-black-64;
      border-radius: 24px 8px 24px 8px;
      border: solid 1px rgba($color-black, 0.4);

      span {
        font-family: 'globotipo' !important;
        font-weight: 500 !important;
      }

      @include for-size(phone-only) {
        flex: 0 0 80%;
        font-size: 0.88em;
      }
    }
    // -------

    // Definições para o slot de ações / botões
    .feedback-actions {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 40px 0 0 0;

      .v-btn {
        margin: 0 4px;
      }

      @include for-size(phone-only) {
        flex: 0 0 100%;
      }
    }
    // -------
  }

  &.empty-search {
    .feedback {
      .feedback-info {
        display: none;
      }
    }
  }

  &.no-folder-access {
    .feedback {
      .feedback-actions {
        a {
          display: none;
        }
      }
    }
  }

  &.no-activities {
    .feedback {
      .feedback-actions,
      .feedback-info {
        display: none;
      }
    }

    .texture {
      display: none;
    }
  }
}
</style>
